import { DOMHelper } from "../Helpers/DOMHelper.js";
import { FormatHelper } from "../Helpers/FormatHelper.js";
import { Modal } from "./Modal.js";
import { PmDatalayer } from "../Datalayer/PmDatalayer.js";

export class NeedHelpForm {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "start-need-help-modal";
		this.captchaId = null;
    }

    init() {
        var $this = this;
        this.needHelpFormModal = new Modal(
            this.app,
            "start-need-help-modal",
            this.getHtml(),
            null,
            "twilio-class"
        );
        this.needHelpFormModal.init();
        this.needHelpFormModal.setHideCallback(()=>{
            //DATALAYERS: CHAT LEAD
            $this.app.shiftDatalayer.fireEvent('chatClosed', {})
            $this.app.pmDRSDatalayer.chatClosedEvent(PmDatalayer.TEXT_US_SECTION)
        })
        this.eventHandlers();
		this.setRecaptchaKeys();
    }

    getFormHtml() {
        return `<div class="">
    <div class="header">
        <h4>Text us!</h4>
        <hr>
    </div>
    <form action="POST" id="form-twilio">
        <input type="hidden" name="leadId" class="pmdrs-hidden-field">
        <input type="hidden" name="vin" class="pmdrs-hidden-field">
        <input type="hidden" name="ajax" value="1">
        <input type="hidden" name="form_title" value="Speed DRA Video Chat">
        <input type="hidden" name="preferredmethodofcontactField" value="Text Messages">

        <div>
            <div class="away-message">
                <div class="away-message-icon">
                    <i class="pmdrs-fa pmdrs-fa-clock-o"></i>
                </div>
                <div class="away-message-msg">
                    <p>Our store is currently closed. We will contact you during regular business hours.</p>
                </div>
            </div>
            <p>Do you need help? Want a professional sales person to talk to? Text us now and we will contact you via text. If you prefer that we call you please check the "Call Me" Box.</p>
            <div class="text-us-group">
                <label class="text-us-label" for="first-name">First Name*</label>
                <input type="text" id="first-name" class="text-us-input information-input" name="pmFirstField" required>
            </div>
            <div class="text-us-group">
                <label class="text-us-label" for="last-name">Last Name*</label>
                <input type="text" id="last-name" class="text-us-input information-input" name="pmLastField" required>
            </div>
            <div class="text-us-group">
                <label class="text-us-label" id="phone" for="phone">Phone<em class="phonerequired" style="display: none;">*</em></label>
                <input type="phone" id="phone" class="text-us-input information-input phone-input" name="pmPhoneField" maxlength="12" placeholder="123-456-7890" required="false">
            </div>
            <div class="text-us-group message-area">
                <label class="text-us-label" for="message">Message</label>
                <textarea  placeholder="Optional" id="message" class="text-us-input message" name="pmMessageField" ></textarea>
            </div>
            <div class="text-us-group message-area">
                <p style="word-wrap:break-word; display: flex; align-items: center;" class="text-us-label" >Call me
                    <input style="margin-bottom: 0; width: 15px; height: 15px; margin-left: 10px;" id="checkid"  type="checkbox" name="pmCallMeField" />
                </p>
            </div>
            <div class="text-us-group preferred-time-to-call" style="margin-top: 10px; display: none;">
                <label for="call-back-preference">Preferred Time to Call <span style="font-weight: 100;">(optional)</span></label>
                <select name="pmPreferredTimeToCall" id="call-back-preference">
                    <option value="morning">Morning</option>
                    <option value="afternoon">Afternoon</option>
                    <option value="evening">Evening</option>
                </select>
            </div>
            <div class="text-us-group">
                <label class="checkbox-label ccpa-description" style="">
                    <input type="checkbox" name="ccpa-checkbox" value="HTML" style="margin-right:7px;" required />
                    <span>
                    *By checking here, I direct this site to send me text messages to market or advertise products, goods, or services. These text messages may be transmitted through autodialed calls or robotext. By checking the checkbox and
                    clicking submit, I confirm that I am the current owner/subscriber of the mobile number provided or that the current owner/subscribed of this mobile phone number authorized me to provide this number to the dealer. I
                    understand that my consent is not required as a condition of purchase and that I can revoke my consent at any time. My carrier wireless and text message fees may apply. I will contact the dealer directly to provide
                    reasonable notice if I no longer wish to receive automated calls or texts.
                    </span>
                </label>
            </div>
            <div class="text-us-group">    
                <label class="checkbox-label tcpa-description" style="">
                    <input type="checkbox" name="tcpa-checkbox" value="HTML" style="margin-right:7px;"  required/>
                    <span>
                    *By submitting this form I understand that this site may contact me with offers or information about their products and service.
                    </span>
                </label>

            </div>
            <div class="g-recaptcha" data-sitekey=""></div>

            <p class="error-message" style="color: red" id="pmdrs-twilio-error"></p>
            <p class="success-message" id="pmdrs-twilio-success">Success</p>
            <input type="hidden" id="pmTwilioSend" name="pmTwilioSend" value="1">
        </div>
        <div class="drs-twilio-footer">
            <button id="twilio-submit">Submit</button>
        </div>
    </form>
</div>`;
    }

    getIframeHtml() {
        const siteToken = this.app.pmdrs.config.accountId;
        const baseUrl = this.app.pmdrs.pmApi.getRootURL();
        return `<iframe src="${baseUrl}iframe/text-us/${siteToken}" style="width:100%;height:550px;border:none;display:block;" frameborder="0" allowtransparency="true"></iframe>`;
    }

    getHtml() {
        return false 
        ? this.getIframeHtml() 
        : this.getFormHtml();
    }

    eventHandlers() {
        var $this = this;
        //phone format
        DOMHelper.addHandler(this.getSelector("#phone"), "keyup", (event) => {
            if (event.target.value != "") {
                event.target.value = FormatHelper.phoneNumberFormat(event.target.value);
            }
        });

        //open modal
        DOMHelper.addHandler(this.app.getSelector("button.need-help-btn"), 'click', () => {
            $this.needHelpFormModal.show();
        });        

        //submit
        let submitTwilioMsg = function (event) {
            console.log("twilio");
            event.preventDefault();
            // FRONT CAPTCHA CHECK
            var captchaResponse = grecaptcha.getResponse($this.captchaId);
            if (captchaResponse.length === 0) {
                $this.showErrorMsg("Please complete the captcha");
                return false;
            }

            console.log(event.target);
            $this.sendTwilioMsg(event);
            return false;
        };
        DOMHelper.addHandler(this.getSelector("#form-twilio"),"submit", submitTwilioMsg);

    }

    setRecaptchaKeys(){		
            if(typeof grecaptcha === 'undefined') {
                console.warn('Google recaptcha missing');
                return;
            }

            if(typeof grecaptcha.render !== 'function') {
                console.warn('Google recaptcha.render missing');
                return;
            }
    
            var $this = this;
            let item = document.querySelector($this.getSelector(".g-recaptcha"));
            this.captchaId = grecaptcha.render(item, {
                  'sitekey' : $this.app.config.recaptchaSiteKey,
                  'callback' : () => {
                    $this.app.pmDRSDatalayer.generalClickEvent(PmDatalayer.TEXT_US_SECTION, 'recaptcha' , item)
                  }
            });
        }

    sendTwilioMsg(event) {
        var $this = this;
        console.log(event.target);
        var twilioForm = new FormData(event.target);
        twilioForm.set('ftid', this.app.generateFTID(twilioForm.get('leadId')));
        twilioForm = this.app.dealPage.addExtraFormData(twilioForm);

        let successMsg = document.querySelector("#pmdrs-twilio-success");
        // setTimeout(() => {
        //     this.needHelpFormModal.hide();
        // }, 2000);
        return this.app.pmdrs.pmDealersite.sendTwilioMsg(
            twilioForm,
            (response) => {
                //SEND LEAD to api.dtm
                $this.app.pmdrs.pmApiDtm.postChatLead(
                    twilioForm,
                    (apiDtmResponse) => {
                        console.log('Chat Lead Saved on api.dtm');
                    },
                    (apiDtmError) => {
                        console.log(apiDtmError);
                    }
                );
                //hide MODAL
                console.log("success");
                successMsg.style.display = "block";
                console.log(response);
                setTimeout(() => {
                    this.needHelpFormModal.hide();
                }, 2000);
                const leadId = twilioForm.get("leadId");

                //DATALAYERS: SUBMIT EVENT
                $this.app.shiftDatalayer.fireEvent('formSubmission', {leadId:leadId, formType: 'contact us'})
                $this.app.pmDRSDatalayer.submitEvent(PmDatalayer.TEXT_US_SECTION, 'form', event.target)

                //DATALAYERS: CHAT LEAD
                $this.app.shiftDatalayer.fireEvent('chatLead', {chatLeadId: leadId})
                $this.app.pmDRSDatalayer.chatLeadEvent(PmDatalayer.TEXT_US_SECTION, leadId, twilioForm)
                
                //DATALAYERS: CHAT MESSAGE
                const chatMsg = twilioForm.get("pmMessageField")
                 + (twilioForm.has("pmCallMeField") ? ' - call me' : '');
                $this.app.shiftDatalayer.fireEvent('chatMessage', {chatMessageContent: chatMsg})
                $this.app.pmDRSDatalayer.chatMessageEvent(PmDatalayer.TEXT_US_SECTION, chatMsg)

            },
            (error) => {
                console.log("error");
                // successMsg.style.display = "block";
                console.log(error);
                // setTimeout(() => {
                //     this.needHelpFormModal.hide();
                // }, 2000);
            }
        );
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }

    showErrorMsg(msg) {
        var selector = this.getSelector("#pmdrs-twilio-error");
        DOMHelper.setInnerHTML(selector, msg);

        setTimeout(() => {
            DOMHelper.setInnerHTML(selector, "");
        }, 5000);
    }

    setBackgroundColor(make) {
        let background = "";
        if (make.toLowerCase() == "indian motorcycle") {
            background = "indian-background";
        } else {
            background = "bmw-background";
        }
        DOMHelper.addClass(this.getSelector(".drs-twilio-footer"), background);
    }
}
